<script lang="ts" setup>
import { SUPPLIER_TAB_ROUTER_INFO } from '../constants';
import { useRoute } from 'vue-router';
import HeaderArea from '@/corePagesModule/components/HeaderArea.vue';
import { i18n } from '@/i18n';
import { IRouterInfo } from '@/coreDomainsModule/entities/routerInfo';

const tabInfos = [...SUPPLIER_TAB_ROUTER_INFO];

const route = useRoute();
const t = i18n.t;
</script>

<template>
  <div class="supplier-forecast-dashboard">
    <HeaderArea :title="t('仕入先内示')" />
    <template v-for="info in tabInfos" :key="info.router">
      <component :is="info.component" v-if="route.path === info.router" class="supplier-forecast-dashboard__container" />
    </template>
  </div>
</template>

<style lang="scss" scoped>
.supplier-forecast-dashboard {
  width: 100%;
  height: 100%;
  background-color: $backgroundDefault;
  padding: 0 16px;
  display: grid;
  grid-template-rows: auto 1fr;

  &__container {
    height: 100%;
  }
}
</style>
